const mockedNarrators = [
  {
    value: 'Swen',
    text: 'Swen Swensson',
  },
  {
    value: '234wersdf',
    text: 'Johan Johansson',
  },
];

export default mockedNarrators;
